<template>
  <v-container class="fill-height">
    <v-row
      align="center"
      justify="center"
      v-if="!submitted && requester && requester.validated === null"
    >
      <v-col cols="12" sm="8">
        <div>
          {{ requester.firstname }} {{ requester.lastname }} a indiqué vouloir
          faire du covoiturage avec vous.
        </div>
        <div class="mt-5">
          Si cette information est correcte, veuillez, s'il vous plait
          renseigner votre adresse et accepter sa demande.
        </div>
        <div class="mt-10">
          <v-autocomplete
            outlined
            dense
            label="Votre adresse"
            v-model="address"
            :items="addresses"
            :search-input.sync="searchAddresses"
            :loading="loadingAddresses"
            :filter="customFilter"
            v-if="addressType === 'local'"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>Recherchez une adresse...</v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ attr, on, item }">
              <div v-html="item.text"></div>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-html="item.text"></v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-textarea
            label="Votre adresse"
            outlined
            dense
            v-if="addressType === 'aborad'"
            v-model="address.label"
          ></v-textarea>
        </div>
        <div class="mt-5">
          <v-btn
            outlined
            :disabled="Object.keys(address).length === 0 || submitting"
            @click="submit(true)"
            >Accepter</v-btn
          >
          <v-btn
            outlined
            class="ml-4"
            :disabled="submitting"
            @click="submit(false)"
            >Refuser</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center"
      v-if="requester && requester.validated !== null && !submitted"
      >Ce lien de validation a expiré.</v-row
    >
    <v-row
      align="center"
      justify="center"
      v-if="submitted && requester.validated !== null"
      >Merci pour votre réponse!</v-row
    >
  </v-container>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  async mounted() {
    const { data: requester } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/carpool/${this.$route.params.nano}`,
    });
    this.requester = requester;
  },
  data: () => ({
    requester: undefined,
    searchAddresses: null,
    addresses: [],
    address: {},
    submitted: false,
    submitting: false,
    addressType: "local",
  }),
  methods: {
    async queryAddresses(v) {
      this.loadingAddresses = true;

      try {
        const { data: mapboxData } = await axios({
          method: "get",
          url: process.env.VUE_APP_MAPBOX_URL,
          params: {
            q: v,
            access_token:
              process.env.VUE_APP_MAPBOX_TOKEN,
            language: "fr",
            country: "CH,FR,DE,IT",
            types: "address,street",
            proximity: "46.779089,6.659356",
          },
        });

        this.addresses = mapboxData.features.map((r) => ({
          text: r.properties.full_address,
          value: {
            label: r.properties.full_address,
            lat: r.geometry.coordinates[1],
            lon: r.geometry.coordinates[0],
          },
        }));
      } catch (error) {
        console.error("Error fetching addresses:", error);
        this.addresses = [];
      } finally {
        this.loadingAddresses = false;
      }
    },
    customFilter(item, queryText) {
      const normalizedQuery = this.normalizeText(queryText);
      const normalizedAddress = this.normalizeText(item.text);

      // Split query into parts (e.g., "rue du test city" -> ["rue", "du", "test", "city"])
      const queryParts = normalizedQuery.split(" ");

      // Check if all parts of the query exist in the address
      return queryParts.every((part) => normalizedAddress.includes(part));
    },

    normalizeText(text) {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
        .replace(/[^a-z0-9\s]/g, " ") // Replace special chars with spaces
        .replace(/\s+/g, " ") // Replace multiple spaces with single space
        .trim();
    },
    async submit(choice) {
      this.submitting = true;
      const { data } = await axios({
        method: "post",
        url: `${process.env.VUE_APP_API_URI}/carpool/${this.$route.params.nano}`,
        data: {
          choice,
          address: this.address,
        },
      });
      this.requester.validated = data.validated;
      this.submitted = true;
      this.submitting = false;
    },
  },
  watch: {
    searchAddresses: _.debounce(function (val) {
      val && val !== this.address && this.queryAddresses(val);
    }, 500),
    addressType: function () {
      this.address = {};
    },
  },
};
</script>
